import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ComputedIndicatorSelector = _resolveComponent("ComputedIndicatorSelector")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog) = $event)),
    title: 'Ajouter un indicateur | ratio',
    minWidth: '800px',
    maxWidth: '800px',
    actions: _ctx.actions,
    onClose: _ctx.reset,
    "previous-display": _ctx.previousDisplay,
    onPrevious: _cache[9] || (_cache[9] = ($event: any) => (_ctx.previous())),
    prefixDataCy: "ChoosePersonalisedCard-valid"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        "grid-list-md": ""
      }, {
        default: _withCtx(() => [
          (!_ctx.vue)
            ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Que souhaitez-vous afficher ?")
                ])),
                _: 1
              }))
            : (!_ctx.ratio)
              ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 1 }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Choisissez un indicateur à afficher")
                  ])),
                  _: 1
                }))
              : (_ctx.vue === 1)
                ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 2 }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Choisissez le type de ratio à afficher")
                    ])),
                    _: 1
                  }))
                : (!_ctx.ratioPersonalised)
                  ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 3 }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("Choisissez le ratio qui vous interesse")
                      ])),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 4 }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Choisissez 2 éléments clés à comparer")
                      ])),
                      _: 1
                    })),
          _createVNode(_component_v_window, {
            modelValue: _ctx.wizardStep,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.wizardStep) = $event)),
            touchless: "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.passerVue2SansRatio())),
                        "data-cy": "choosePersonalisedCard-indicator"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode("Un Indicateur")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("Afficher un élément clé de l'entreprise (Charges sociales, ...)")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.passerVue2Ratio())),
                        "data-cy": "choosePersonalisedCard-ratio"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode("Un Ratio")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode("Comparer 2 indicateurs entre eux (part du loyer dans les charges, ...)")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ComputedIndicatorSelector, {
                    companyId: _ctx.companyId,
                    onComputedIndicatorSelected: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addComputedIndicator($event)))
                  }, null, 8, ["companyId"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.passerVue3RatioNonPersonalises())),
                        "data-cy": "ChoosePersonalisedCard-ratioPreDefini-list-item"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("Un ratio pré-défini")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode("Afficher l'une des comparaisons les plus souvent faites")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, {
                        class: "oss-list-item mb-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passerVue3RatioPersonalises())),
                        "data-cy": "ChoosePersonalisedCard-ratioPerso-list-item"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("Un ratio personnalisé")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("Comparer 2 indicateurs que vous choisissez")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ComputedIndicatorSelector, {
                    companyId: _ctx.companyId,
                    definedOperator: 'v1/v2',
                    operatorsWanted: ['v1/v2'],
                    dontAllowCreation: true,
                    onComputedIndicatorSelected: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addComputedIndicator($event)))
                  }, null, 8, ["companyId"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ComputedIndicatorSelector, {
                    companyId: _ctx.companyId,
                    definedOperator: 'v1/v2',
                    actions: _ctx.CI_selectorActions,
                    onComputedIndicatorSelected: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createRatio($event)))
                  }, null, 8, ["companyId", "actions"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "actions", "onClose", "previous-display"]))
}